@if (nav.selectedQueryId()) {
  <div>
    <div id="package-details-query-selected-view">
      <!-- Header -->
      <div id="query-selected-header">
        <div id="header-left">
          <hyperkit-typography display="inline" variant="h4">
            {{ query()?.title }}
          </hyperkit-typography>
          <hyperkit-badge
            variant="neutral"
            [text]="query()?.category"
          ></hyperkit-badge>
        </div>
        <div id="header-right">
          <hyperkit-button-group>
            @for (btn of statusButtons(); track btn) {
              <hyperkit-button
                size="small"
                [text]="btn.label"
                [icon]="btn.icon"
                [iconColor]="btn.label | queryStatusColor"
                [color]="btn.selected ? 'primary' : 'secondary'"
                (buttonClick)="btn.onClick()"
              >
              </hyperkit-button>
            }
          </hyperkit-button-group>
        </div>
      </div>
      <!-- Tabs -->
      <hyperkit-tab-bar [controlled]="true">
        <hyperkit-tab
          text="Overview"
          [selected]="isSelectedTab('overview')"
          (tabClick)="nav.setSelectedPivotTab('overview')"
        ></hyperkit-tab>
        <hyperkit-tab
          text="Deployment Requirements"
          [selected]="isSelectedTab('deployment')"
          (tabClick)="nav.setSelectedPivotTab('deployment')"
        ></hyperkit-tab>
        <hyperkit-tab
          text="Emulation and Validation"
          [selected]="isSelectedTab('emulation')"
          (tabClick)="nav.setSelectedPivotTab('emulation')"
        ></hyperkit-tab>
      </hyperkit-tab-bar>
      <!-- Tab Content -->
      <div class="tab-panel-content">
        @if (isSelectedTab('overview')) {
          <query-selected-overview-tab></query-selected-overview-tab>
        }
        @if (isSelectedTab('deployment')) {
          <query-selected-deployment-requirements-tab></query-selected-deployment-requirements-tab>
        }
        @if (isSelectedTab('emulation')) {
          <query-selected-emulation-validation-tab></query-selected-emulation-validation-tab>
        }
      </div>
    </div>
  </div>
} @else {
  <div style="color: red; padding: 1rem">No query selected</div>
}
